import { Box } from '@mui/material';
import React from 'react';
import { PlaceholderContactProps } from '../../models/PlaceholderContact';
import { Palette } from 'Palette';
import { StyledButton, StyledButtonGroup } from '../styles/StyledButtons';
import { StyledTypography } from '../styles/styles';

interface PlaceholderContactDetailsViewProps {
  placeholder: PlaceholderContactProps;
  tone?: keyof typeof Palette;
  submitting: boolean;
  onEdit: () => void;
  onPromote: () => void;
}

const PlaceholderContactDetailsView: React.FC<PlaceholderContactDetailsViewProps> = ({
  placeholder,
  tone = 'default',
  submitting,
  onEdit,
  onPromote,
}) => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      mb: 3,
    }}
  >
    <Box>
      <StyledTypography variant="h6" tone={tone}>
        {placeholder.firstName} {placeholder.lastName}
      </StyledTypography>
      <StyledTypography variant="body2" tone={tone}>
        {placeholder.email}
      </StyledTypography>
      <StyledTypography variant="body2" tone={tone}>
        Role: {placeholder.role}
      </StyledTypography>
      {placeholder.representativeType && (
        <StyledTypography variant="body2" tone={tone}>
          Representative Type: {placeholder.representativeType}
        </StyledTypography>
      )}
      {placeholder.otherRepresentativeType && (
        <StyledTypography variant="body2" tone={tone}>
          Other Type: {placeholder.otherRepresentativeType}
        </StyledTypography>
      )}
      <StyledTypography variant="body2" tone={tone}>
        Created: {new Date(placeholder.createdAt).toLocaleDateString()}
      </StyledTypography>
    </Box>
    <StyledButtonGroup>
      <StyledButton variant="contained" onClick={onEdit} disabled={submitting}>
        Edit
      </StyledButton>
      <StyledButton variant="contained" onClick={onPromote} disabled={submitting}>
        Promote as is
      </StyledButton>
    </StyledButtonGroup>
  </Box>
);

export default PlaceholderContactDetailsView;
